import { forwardRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./AnimatedWidthButton.scss";
import useMeasure from "react-use-measure";
import { ArrowDownIcon } from "app/icons/navigation";
import { ICON_SIZES } from "app/constants";

export const AnimatedWidthButton = forwardRef(
	(
		{
			className,
			isActive = false,
			isOpen = false,
			children,
			["data-testid"]: dataTestId,
			...props
		},
		ref
	) => {
		const [ghostRef, bounds] = useMeasure();
		const [enableTransition, setEnableTransition] = useState(false);

		useEffect(() => {
			if (!window.matchMedia) {
				return;
			}

			const shouldReduceMotion = window.matchMedia(
				"(prefers-reduced-motion: reduce)"
			).matches;

			if (!shouldReduceMotion) {
				setEnableTransition(true);
			}
		}, []);

		return (
			<button
				className={classNames("animated-width-button", className)}
				data-active={isActive}
				type="button"
				data-transition={enableTransition}
				ref={ref}
				style={{ width: bounds.width || undefined }}
				{...props}
			>
				<span className="animated-width-button__content-main" data-testid={dataTestId}>
					{children}
					<ArrowDownIcon rotated={isOpen} size={ICON_SIZES.XXS} />
				</span>

				<span
					className="animated-width-button__content-ghost"
					ref={ghostRef}
					aria-hidden="true"
				>
					<span className="animated-width-button__content-main">
						{children}
						<ArrowDownIcon rotated={isOpen} size={ICON_SIZES.XXS} />
					</span>
				</span>
			</button>
		);
	}
);

AnimatedWidthButton.propTypes = {
	className: PropTypes.string,
	isActive: PropTypes.bool,
	isOpen: PropTypes.bool,
	children: PropTypes.node.isRequired,
};
